const httpAdapter = null;
export {
  httpAdapter as default
};
//# sourceMappingURL=axios32.js.map
